import { connect } from 'react-redux';
import api from '../../../../utils/api';
import { push } from 'connected-react-router';
import SubscriptionsNewView from '../components/SubscriptionsNewView';
import {
    changeSubscriptionStep,
    clearSubscriptionData,
    saveReceivers,
    selectSubscriptionType,
    updateReceivers,
    updateSubscriptionConfiguration,
} from '../actions';
import { fromJS } from 'immutable';

const mapActionCreators = dispatch => ({
    dispatch: payload => dispatch(payload),
    push: payload => dispatch(push(payload)),
    selectSubscriptionType: payload => dispatch(selectSubscriptionType(payload)),
    updateSubscriptionConfiguration: payload => dispatch(updateSubscriptionConfiguration(payload)),
    changeSubscriptionStep: payload => dispatch(changeSubscriptionStep(payload)),
    updateReceivers: payload => dispatch(updateReceivers(payload)),
    saveReceivers: payload => dispatch(saveReceivers(payload)),
    createSubscription: payload => dispatch(api.actions.subscriptions.addSubscription(payload)),
    clearSubscriptionData: () => dispatch(clearSubscriptionData()),
    submitCouponCode: payload => dispatch(api.actions.coupons.submitCoupon(payload)),
    fetchPlans: payload => dispatch(api.actions.plans.fetch()),
});

const mapStateToProps = state => ({
    subscriptionDetails: state.subscriptions.get('newSubscription'),
    isFetching: state.subscriptions.get('isFetching'),
    isFetchingCoupon: state.coupons.get('isFetching'),
    showNoAccountWarning:
        state.user.getIn(['billwerk_customer_id'], null) === null &&
        state.account.getIn(['Id'], undefined) === undefined
            ? true
            : false,
    plans: state.plans.getIn(['plans'], fromJS([])),
    coupons: state.coupons.getIn(['coupons'], fromJS({})),
    coupon: state.coupons.getIn(
        [state.subscriptions.getIn(['newSubscription', 'planVariantId'], '')],
        fromJS({})
    ),
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(SubscriptionsNewView);
